import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';
import { COLUMN_WIDTH } from '../../../../constants/ColumnWidth';
import { usePermission } from '../../../../hooks';
import { useGenGridCol } from '../../../../utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';

interface IProps {
  renderApprovalProgressCell: (props: any) => JSX.Element;
  renderOperationsCell: (props: any) => JSX.Element;
}

const useTableColumns = (props: IProps) => {
  const { renderApprovalProgressCell, renderOperationsCell } = props;

  const { hasPermission } = usePermission();

  const hasApprovePermission = hasPermission(
    AgentPortalFeatureCode.Rebate.RebateDistributionTask.Approve.prefix
  );
  const hasRejectPermission = hasPermission(
    AgentPortalFeatureCode.Rebate.RebateDistributionTask.Reject
  );

  const columns = [
    useGenGridCol(TableColumnKey.Operation, {
      renderCell: renderOperationsCell,
      hide: !hasApprovePermission && !hasRejectPermission,
    }),

    useGenGridCol(TableColumnKey.TaskId),
    useGenGridCol(TableColumnKey.Month),
    useGenGridCol(TableColumnKey.ApprovalProgress, {
      minWidth: COLUMN_WIDTH.ApprovalProgress.MinWidth,
      renderCell: renderApprovalProgressCell,
    }),

    useGenGridCol(TableColumnKey.ProgramName, {
      minWidth: COLUMN_WIDTH.DistributorAgentId.MinWidth,
    }),
    useGenGridCol(TableColumnKey.Currency),
    useGenGridCol(TableColumnKey.RebateCurrency),
    useGenGridCol(TableColumnKey.RebateExchangeRate),
    useGenGridCol(TableColumnKey.TotalDistributorAgentRebateAmount),
    useGenGridCol(TableColumnKey.TotalClientRebateAmount),
    useGenGridCol(TableColumnKey.NetTotalDistributorAgentRebateAmount),
    useGenGridCol(TableColumnKey.Status, {
      minWidth: 120,
    }),
    useGenGridCol(TableColumnKey.Step),
    useGenGridCol(TableColumnKey.CreationTime, {
      minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
    }),
    useGenGridCol(TableColumnKey.LastModifiedTime, {
      minWidth: COLUMN_WIDTH.LastModifiedDate.MinWidth,
    }),
  ];

  return columns;
};

export default useTableColumns;
